import React, { useState } from "react";
import "./Sort_By_Offcanvas.css";
import { Form, Offcanvas } from "react-bootstrap";

const Sort_By_Offcanvas = ({ show, handleClose,selectedSort ,setSelectedSort}) => {
 

  const sortOptions = [
    // { label: "POSITION", value: "position" },
    { label: "NAME : A TO Z", value: "NameAscending" },
    { label: "NAME : Z TO A", value: "NameDescending" },
    { label: "PRICE : LOW TO HIGH", value: "PriceAscending" },
    { label: "PRICE : HIGH TO LOW", value: "PriceDescending" },
    // { label: "COUNTRY OF MANUFACTURE", value: "country" },
  ];

  return (
    <Offcanvas
      show={show}
      onHide={handleClose}
      placement="end"
      className="Filter_By_Offcanvas"
    >
      <Offcanvas.Header className="sort_header">
        <Offcanvas.Title className="sort_title">SORT BY</Offcanvas.Title>

        <div className="close_holder" onClick={handleClose}>
          <img
            src="/assest/luxury_images/other/cancel.png"
            className="close_img"
            alt="close"
          />
        </div>
      </Offcanvas.Header>

      <Offcanvas.Body className="filter_div">
        <Form className="sort_form">
          {sortOptions.map((item, index) => (
            <div className="sort_option" key={index}>
              <Form.Group className="mb-3" controlId="formBasicCheckbox">
                <Form.Check
                  type="checkbox"
                  name="sort"
                  label={item.label}
                  value={item.value}
                  checked={selectedSort === item.value}
                  onChange={(e) => setSelectedSort(e.target.value)}
                />
              </Form.Group>
            </div>
          ))}
        </Form>
      </Offcanvas.Body>
    </Offcanvas>
  );
};

export default Sort_By_Offcanvas;
